import { mask } from 'vue-the-mask'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'
import ExpenseRepository from '@/shared/http/repositories/configurations/expensetype.js'

function DespesasModel () {
  this.id = null
  this.tipoDespesa = null
  this.observacao = null
  this.anexo = false
  this.idDespesa = 0
  this.valor = ''
}

export default {
  name: 'ModalDespesas',
  directives: { mask },
  mixins: [ActionsForm],
  data () {
    return {
      listOfDespesas: [],
      files: [],
      expenseOptions: [],
      expectedAttachments: 0
    }
  },
  props: {
    listFromParent: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    requiredAttach () {
      return this.listOfDespesas.reduce((count, despesa) => {
        if (despesa.anexo) {
          count++
        }
        return count
      }, 0)
    }
  },
  methods: {
    async onLoad () {
      const response = await ExpenseRepository.GetAll()
      var data = response.data.content
      for (var i in data) {
        this.expenseOptions.push({ 'text': data[i].nome, 'value': data[i].id, anexo: data[i].anexo })
      }

      this.listFromParent.map(p => {
        const despesa = this.expenseOptions.find(x => x.text === p.tipoDespesa)

        if (!despesa) {
          this.expenseOptions.push({ 'text': p.tipoDespesa, 'value': p.tipoDespesa, anexo: false, disabled: true })
          p.idDespesa = p.tipoDespesa
        } else {
          p.idDespesa = despesa.value
        }
        p.anexo = false

        return p
      })

      this.listOfDespesas = this.listFromParent

      this.expectedAttachments = 0

      this.listOfDespesas.forEach(x => {
        if (x.anexo && !x.id) {
          this.expectedAttachments++
        }
      })

      this.$root.$on('bv::modal::hide', () => this.$emit('onBackDespesas', this.listOfDespesas))
    },
    showModal () {
      this.$refs['modal-column'].show()
    },
    hideModal () {
      this.$refs['modal-column'].hide()
    },
    onAdd () {
      this.listOfDespesas.push(new DespesasModel())
    },
    onRemove (pos) {
      this.listOfDespesas.splice(pos, 1)
    },
    onUploadClick () {
      this.$refs.inputFile.click()
    },
    onUploadDragover (event) {
      event.preventDefault()
    },
    onUploadDrop (event) {
      event.preventDefault()
      let files = event.dataTransfer.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onFileChange (event) {
      event.preventDefault()
      let files = event.target.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onDeleteFile (file) {
      this.files = this.files.filter((files) => files !== file)
    },
    onChangeOption (data) {
      let despesa = this.expenseOptions.find(x => x.value === data.idDespesa)
      console.log(despesa)
      data.anexo = despesa.anexo
      data.tipoDespesa = despesa.text

      this.expectedAttachments = 0

      this.listOfDespesas.forEach(x => {
        if (x.anexo) {
          this.expectedAttachments++
        }
      })
    },
    onSaveDespesa () {
      if (this.requiredAttach && this.files.length === 0) {
        toast.warning(`Despesas requer pelo menos ${this.requiredAttach} anexo(s)`)
      } else {
        this.hideModal()
        this.$emit('onBackDespesasFiles', this.files)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/despesasModal/despesas.js